import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import {
  CircleCheckBigIcon,
  CircleXIcon,
  PartyPopperIcon,
  TimerIcon,
  TriangleAlertIcon,
} from "lucide-react";

export const ExamSummaryContent = ({
  time,
  correct,
  incorrect,
  questionsCount,
  finalScore,
  isPassed,
}: {
  time: string;
  correct: number;
  incorrect: number;
  questionsCount: number;
  finalScore: number;
  isPassed: boolean;
}) => {
  return (
    <div className={"grid grid-cols-1 gap-6 md:grid-cols-2"}>
      {isPassed ? (
        <ExamSummaryStat
          title={"Egzamin zdany"}
          value={`${finalScore}%`}
          icon={
            <PartyPopperIcon size={16} className={"stroke-remedium-blue"} />
          }
        />
      ) : (
        <ExamSummaryStat
          title={"Egzamin niezdany"}
          value={`${finalScore}%`}
          icon={<TriangleAlertIcon size={16} className={"stroke-red-700"} />}
        />
      )}

      <ExamSummaryStat
        title={"Czas trwania egzaminu"}
        value={time}
        icon={<TimerIcon size={16} className={"stroke-remedium-blue"} />}
      />

      <ExamSummaryStat
        title={"Poprawne odpowiedzi"}
        value={`${correct}/${questionsCount}`}
        icon={<CircleCheckBigIcon size={16} className={"stroke-teal-700"} />}
      />

      <ExamSummaryStat
        title={"Błędne odpowiedzi"}
        value={`${incorrect}/${questionsCount}`}
        icon={<CircleXIcon size={16} className={"stroke-red-700"} />}
      />
    </div>
  );
};

export const ExamSummaryStat = ({
  title,
  value,
  icon,
}: {
  title: string;
  value: string;
  icon: ReactNode;
}) => {
  return (
    <div
      className={cn(
        "flex h-[108px] flex-col justify-between rounded-lg border px-6 py-6",
      )}
    >
      <div className={"mb-2 flex items-center justify-between"}>
        <div className={cn(`text-card-foreground text-sm font-medium`)}>
          {title}
        </div>
        <div className={"flex items-center"}>{icon}</div>
      </div>
      <div className={cn(`text-card-foreground text-2xl font-bold`)}>
        {value}
      </div>
    </div>
  );
};
